import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../Config";
import UploadWidget from "./Components/UploadWidget";

const Projects = (props) => {
  const [UploadCount, setUploadCount] = useState(0);
  const [UploadInProgress, setUploadInProgress] = useState(false);
  const [ProjectsHadErrors, setProjectsHadErrors] = useState(false);
  const [ProjectAssignmentHadErrors, setProjectAssignmentHadErrors] =
    useState(false);
  const [FirstDialogIsOpen, setFirstDialogIsOpen] = useState(false);
  const [GenerateDescFor, setGenerateDescFor] = useState(null); //"ALL" | "WITHOUT_DESCRIPTION_ONLY" | null (no skill generation)
  const [SecondDialogIsOpen, setSecondDialogIsOpen] = useState(false);

  var CheckFileCountTimer;

  useEffect(() => {
    CheckFileCountTimer = setInterval(updatePrevFileCount, 100);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleCheckboxChange = (Id, GenerateSkillValue) => {
    let IsChecked = document.getElementById(Id).checked;

    if (IsChecked) {
      setGenerateDescFor(GenerateSkillValue);
      props.SetGenerateProjectDescFor(GenerateSkillValue);
    } else {
      setGenerateDescFor(null);
      props.SetGenerateProjectDescFor(null);
    }
  };

  const validateFileSize = (FileSize, Id) => {
    setTimeout(() => {
      if (FileSize <= 1) {
        document.getElementById(Id).innerHTML = translateText(
          "data_import_widget_error_non_empty"
        );
      }
    }, 100);
  };

  // this function is called after each file is uploaded inside the then promise, to
  // check the uploaded file extension and in case it is wrong (non-csv) it will set an
  // innerHTML for the error <p></p> tag with the relevant Id. FileName and ErrorElementId
  // are passed down as params to the function call and are different for each upload widget and
  // each uploaded file.
  const validateUploadedFileExtension = (FileName, ErrorElementId) => {
    let FileExtention = FileName.slice(FileName.indexOf("."), FileName.length);

    if (document.getElementById(ErrorElementId) !== null) {
      if (FileExtention !== ".csv") {
        document.getElementById(ErrorElementId).innerHTML =
          "Please upload a csv file.";
      }
    }
  };

  const updatePrevFileCount = () => {
    var Count = 0;
    for (let i = 1; i < 3; i++) {
      if (
        document.getElementById("csv-" + i + "-check") !== null &&
        document
          .getElementById("csv-" + i + "-check")
          .classList.contains("feather-check")
      ) {
        Count++;
      }
    }
    if (Count === 2) {
      clearInterval(CheckFileCountTimer);
    }
    setUploadCount(Count);
  };

  const handleUploadEnd = () => {
    setTimeout(() => {
      updatePrevFileCount();
    }, 300);
  };

  // Projects.csv file upload handler
  const uploadProjectsCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-1-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.DataImportURL + "/api/project/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-1-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setProjectsHadErrors(false);
        } else {
          setProjectsHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-1-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setProjectsHadErrors(true);
      });
  };

  // ProjectAssignment.csv file upload handler
  const uploadProjectAssignmentCSV = () => {
    let Data = new FormData();
    Data.append("file", document.getElementById("csv-2-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/project-assignment/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-2-error");
        handleUploadEnd();
        if (Res.data.status === "SUCCESS") {
          setProjectAssignmentHadErrors(false);
        } else {
          setProjectAssignmentHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-2-error");
      })
      .catch((Err) => {
        console.log(Err.response);
        setProjectAssignmentHadErrors(true);
      });
  };

  return (
    <div className="simple-form">
      <section className="form-head">
        <h1>
          {translateText("projects_files")}
          <p className="opt-info">{"(" + translateText("optional") + ")"}</p>
        </h1>
      </section>
      <div className="form-body">
        <p className="info-top">
          {UploadCount +
            " " +
            translateText("of") +
            " " +
            "2 " +
            translateText("files_uploaded_successfully")}
        </p>
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadProjectsCSV()}
          Enum={"PROJECT"}
          API_Name={"project"}
          UploadHadErrors={ProjectsHadErrors}
          SwitchErrorState={() => setProjectsHadErrors(!ProjectsHadErrors)}
          Placeholder="Projects.csv"
          Id="csv-1"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setProjectsHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadProjectAssignmentCSV()}
          Enum={"PROJECT_ASSIGNMENT"}
          API_Name={"project-assignment"}
          UploadHadErrors={ProjectAssignmentHadErrors}
          SwitchErrorState={() =>
            setProjectAssignmentHadErrors(!ProjectAssignmentHadErrors)
          }
          Placeholder="ProjectAssignment.csv"
          Id="csv-2"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => handleUploadEnd()}
          RemoveErrorState={() => setProjectAssignmentHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          LangData={props.LangData}
        />
        <section className="checkbox-row">
          <p className="row-text">
            {translateText("generate_description_for_projects")}
          </p>
          <div className="info-holder">
            <i
              className="feather-alert-circle info-alert-icon"
              onMouseEnter={() => setFirstDialogIsOpen(true)}
              onMouseLeave={() => setFirstDialogIsOpen(false)}
            ></i>
            {FirstDialogIsOpen ? (
              <section className="info-popup">
                {translateText("generate_description_for_projects_info")}
              </section>
            ) : null}
            <label
              className={
                GenerateDescFor === "WITHOUT_DESCRIPTION_ONLY" ||
                GenerateDescFor === null
                  ? "blue-checkbox-rounded-label row-item-checkbox"
                  : "blue-checkbox-rounded-label row-item-checkbox disabled-checkbox-wrapper"
              }
            >
              <input
                onChange={() =>
                  handleCheckboxChange(
                    "checkbox-jpa",
                    "WITHOUT_DESCRIPTION_ONLY"
                  )
                }
                type="checkbox"
                id="checkbox-jpa"
                class="blue-checkbox"
                checked={
                  props.GenerateProjectDescFor === "WITHOUT_DESCRIPTION_ONLY"
                    ? true
                    : false
                }
              />
              <i className="check-all"></i>
            </label>
          </div>
        </section>
        <section className="checkbox-row">
          <p className="row-text">
            {translateText("generate_description_for_all_projects")}
          </p>
          <div className="info-holder">
            <i
              className="feather-alert-circle info-alert-icon"
              onMouseEnter={() => setSecondDialogIsOpen(true)}
              onMouseLeave={() => setSecondDialogIsOpen(false)}
            ></i>
            {SecondDialogIsOpen ? (
              <section className="info-popup">
                {translateText("generate_description_for_all_projects_info")}
              </section>
            ) : null}
            <label
              className={
                GenerateDescFor === "ALL" || GenerateDescFor === null
                  ? "blue-checkbox-rounded-label row-item-checkbox"
                  : "blue-checkbox-rounded-label row-item-checkbox disabled-checkbox-wrapper"
              }
            >
              <input
                onChange={() => handleCheckboxChange("checkbox-all", "ALL")}
                type="checkbox"
                id="checkbox-all"
                class="blue-checkbox"
                checked={props.GenerateProjectDescFor === "ALL" ? true : false}
              />
              <i className="check-all"></i>
            </label>
          </div>
        </section>
      </div>
    </div>
  );
};
export default Projects;
